var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { invariant } from "@madmedical/utils";
const openAuth = (getUrl, redirectUrl, onClose) => __awaiter(void 0, void 0, void 0, function* () {
    window.addEventListener("message", ({ data }) => {
        if (data.type !== "oauthResult") {
            return;
        }
        onClose(data.result);
    }, false);
    const width = 500;
    const height = 660;
    const left = window.screenX + (window.outerWidth - width) / 2;
    const top = window.screenY + (window.outerHeight - height) / 2.5;
    const popup = window.open(undefined, "oauth", `toolbar=no,menubar=no,width=${width},height=${height},top=${top},left=${left}`);
    invariant(popup);
    popup.location = yield getUrl();
    popup.onbeforeunload = () => {
        onClose("cancel");
    };
});
export default openAuth;
